import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import DeviceSelector from "../DeviceSelector";
import PlantSelector2 from "../PlantSelector2";

interface DeviceCaseProps {
  selectedPlantId?: number | null;
  selectedVariableId?: number | null;
  onPlantChange?: (plantId: number | null) => void;
  onVariableChange?: (
    variableId: number | null,
    variableName?: string | null,
    variableObj?: any | null,
  ) => void;
}

export default function DeviceCase({
  selectedPlantId,
  selectedVariableId,
  onPlantChange,
  onVariableChange,
}: DeviceCaseProps) {
  const [plantId, setPlantId] = useState<number | null>(
    selectedPlantId || null,
  );
  const [variableId, setVariableId] = useState<number | null>(
    selectedVariableId || null,
  );
  const [selectedVariable, setSelectedVariable] = useState<any>(null);

  // Update local state when props change
  useEffect(() => {
    setPlantId(selectedPlantId || null);
  }, [selectedPlantId]);

  useEffect(() => {
    setVariableId(selectedVariableId || null);
  }, [selectedVariableId]);

  // Reset variable when plant changes to null
  useEffect(() => {
    if (plantId === null) {
      setVariableId(null);
    }
  }, [plantId]);

  const handlePlantChange = (newPlantId: number | null) => {
    setPlantId(newPlantId);
    onPlantChange?.(newPlantId);
  };

  const handleVariableChange = (variableId: number | null, variable: any) => {
    setVariableId(variableId);
    setSelectedVariable(variable);
    onVariableChange?.(
      variableId,
      variable?.variableName || null,
      variable || null,
    );
  };

  return (
    <Box sx={{ gap: 1, display: "flex", flexDirection: "column" }}>
      <PlantSelector2 value={plantId} onChange={handlePlantChange} />
      <DeviceSelector
        plantId={plantId || undefined}
        value={variableId}
        onChange={handleVariableChange}
        disabled={plantId === null}
      />
    </Box>
  );
}
